import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requirePaid = false, allowUnverified = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400"><span className="spinner" /></div>;
  if (!user) return <Navigate to="/register" state={{ from: location }} replace />;
  if (!allowUnverified && !user.college_verified) return <Navigate to="/verify" replace />;
  if (requirePaid && user.payment_status !== "paid") return <Navigate to="/payment" replace />;
  return children;
}
